export default "__VITE_ASSET__5acf0ac5__"